import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS } from '../../_config';
import { CallApi } from '../api/callApi';




export function* GetCountyList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_COUNTY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            if(Object.keys(data).length == 0){
                yield put({
                    type: ACTIONS.MASTER.COUNTY,
                    payload:resp.data?.countyList?.map((countylist: any) => {
                        return {
                            label: countylist.countyName+' - '+countylist.stateName,
                            value: countylist.cuntyID,
                            data:countylist
                        }
                    })
                });
            }
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetStateList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_STATE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            yield put({
                type: ACTIONS.MASTER.STATES,
                payload:resp.data.stateList.map((state: any) => {
                    return {
                        label: state.stateName,
                        value: state.stateID,
                        data:state
                    }
                })
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetCityList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_CITY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            if(Object.keys(data).length == 0){
                yield put({
                    type: ACTIONS.MASTER.CITY,
                    payload:resp.data.cityList.map((citylist: any) => {
                        return {
                            label: citylist.cityName,
                            value: citylist.cityID,
                        }
                    })
                });
            }
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* Getteam(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_TEAM, data,true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            yield put({
                type: ACTIONS.MASTER.TEAMS,
                payload:resp.data.teamList.map((teamlist: any) => {
                    return {
                        label: teamlist.name,
                        value: teamlist.teamID,
                    }
    
                })
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetUser(action: any): any {
    try {
        const data = action.payload;
        if (!data.hasOwnProperty(`pageSize`)) {
            data.pageSize = 5000;
        }
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_USER, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            yield put({
                type: ACTIONS.MASTER.MANAGERS,
                payload:resp.data?.userList?.map((user: any) => {
                    return {
                      label: `${user.lastName}  ${user.firstName}`,
                      value: user.userID,
                    }
            
                  })
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetServiceTechList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_SERVICE_TECH, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            yield put({
                type: ACTIONS.MASTER.SERVICE_TECHS,
                payload:resp.data.serviceTechShortList.map((servicelist: any) => {
                    return {
                        label: servicelist.name,
                        value: servicelist.serviceTechID,
                    }          
                })
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetServiceProviderList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_SERVICE_PROVIDER_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            /*
            let key = ACTIONS.MASTER.ELECTRICITY_PROVIDERS;
            if(data.ServieTypeID == 2){
                key = ACTIONS.MASTER.GAS_PROVIDERS;
            }else if(data.ServieTypeID == 3){
                key = ACTIONS.MASTER.WATER_PROVIDERS;
            }else if(data.ServieTypeID == 4){ 
                key = ACTIONS.MASTER.TELEPHONE_PROVIDERS;
            }
            yield put({
                type: key,
                payload:resp.data.vendorList.map((service: any) => {
                    return {
                        label: service.name,
                        value: service.vendorID,
                    }
                })
            });
            */
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* getTaxes(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_TAXES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* DeleteTeam(action: any): any {
    try {
        const data: any = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.FACILITY.DELETE_TEAM + '?teamID=' + data?.teamID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message || 'Failed to delete team');
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}








 

 



